import {useMemo} from 'react';
import SageUtil from '../../util/sage/SageUtil';

type Input = {
	waiting: boolean;
};

export type useSpinnerType = {
	spinning: boolean;
};

function canSpin() {
	return SageUtil.isSageAccount();
}

export const useSpinner = ({waiting}: Input): useSpinnerType => {
	const enableSpinning = useMemo(() => {
		return waiting && canSpin();
	}, [waiting]);

	return {spinning: enableSpinning};
};
